import React from 'react';
import { Link } from 'react-router-dom';
var aboutPic = require('../../assets/images/about-pic.jpg');

const ManagementBlock = (props) => {	  	
    return(
	<>
	{/* <!-- ABOUT COMPANY SECTION START --> */}
	<div className="section-full p-t80 p-b50">
		<div className="container">
			<div className="row">
				<div className="col-lg-5 col-md-8 m-b30">
					<div className="about-com-pic">
						<img src={aboutPic} alt="" className="img-responsive" />
					</div>
				</div>
				<div className="col-lg-7 col-md-12 m-b30">
					<div className="section-head text-left">
						<h3 className="text-uppercase">About Management </h3>
						<div className="wt-separator-outer">
							<div className="wt-separator style-icon">
								<i className="fa fa-leaf text-black"></i>
								<span className="separator-left site-bg-primary"></span>
								<span className="separator-right site-bg-primary"></span>
							</div>                            
						</div>
						<p>Management is the process of planning, organizing, directing, and controlling workflow, operations, and employees to meet company goals. The primary goal of management is to create an environment that lets employees work efficiently and productively. A solid organizational structure serves as a guide for workers and establishes the tone and focus of their work. </p>
						
					</div>
					<div className="about-types row">
						<div className="col-md-6 col-sm-6 col-xs-6 col-xs-100pc m-b30">
							<div className="wt-icon-box-wraper left">
								<div className="icon-md site-text-primary">
									<Link to="# " className="icon-cell p-t5 center-block"><i className="flaticon-mirror"></i></Link>
								</div>
								<div className="icon-content">
									<h5 className="wt-tilte text-uppercase m-b10">Planning</h5>
									<p>The first function of a manager is to set goals. These goals may be for individual employees, departments, or the entire organization, depending on the manager's level of responsibility. In addition to setting goals, managers often develop action items along with strategies and resources to complete tasks and meet goals. </p>
								</div>
							</div>
						</div>
						<div className="col-md-6 col-sm-6 col-xs-6 col-xs-100pc m-b30 ">
							<div className="wt-icon-box-wraper left">
								<div className="icon-md site-text-primary">
									<Link to="# " className="icon-cell p-t5 center-block"><i className="flaticon-mirror"></i></Link>
								</div>
								<div className="icon-content">
									<h5 className="wt-tilte text-uppercase m-b10">Organizing</h5>
									<p>Meeting organizational goals requires putting the right people in the right places. Managers can play an important role in choosing workers for positions and projects. Knowing how to group people and help them build relationships often significantly affects how well the group works together. Sometimes managers need to train employees for specific tasks to ensure they have the knowledge and skills they need to succeed.</p>
								</div>
							</div>
						</div>
						<div className="col-md-6 col-sm-6 col-xs-6 col-xs-100pc m-b30 ">
							<div className="wt-icon-box-wraper left">
								<div className="icon-md site-text-primary">
									<Link to="# " className="icon-cell p-t5 center-block"><i className="flaticon-mirror"></i></Link>
								</div>
								<div className="icon-content">
									<h5 className="wt-tilte text-uppercase m-b10 ">Motivating</h5>
									<p>Managers help motivate employees to show up and stay productive. This includes sharing a common vision, encouraging them to develop their strengths, and inspiring them to do their best work at all times. Having effective communication skills is essential for filling this role. </p>
								</div>
							</div>
						</div>
						<div className="col-md-6 col-sm-6 col-xs-6 col-xs-100pc m-b30 ">
							<div className="wt-icon-box-wraper left">
								<div className="icon-md site-text-primary">
									<Link to="# " className="icon-cell p-t5 center-block"><i className="flaticon-mirror" aria-hidden="true"></i></Link>
								</div>
								<div className="icon-content">
									<h5 className="wt-tilte text-uppercase m-b10">Evaluating</h5>
									<p>Managers typically spend time measuring the success of their teams and how well they meet goals. The more they understand what works and doesn't work, the better prepared they are to make decisions in the future. Managers must understand and adjust strategies to meet company goals.</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>   
	{/* <!-- ABOUT COMPANY SECTION END --> */} 
    </>
    )
}
export default ManagementBlock;